export default "__VITE_ASSET__BxCjDkj8__"